import { render, staticRenderFns } from "./animated_smile_icon.vue?vue&type=template&id=4110dde6"
import script from "./animated_smile_icon.vue?vue&type=script&lang=js"
export * from "./animated_smile_icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports